import React from 'react';
import PropTypes from 'prop-types';
import './forms/Input.scss';
import './ChangePassword.scss';

import Dialog from './dialogs/Dialog';
import withMeta from './utils/withMeta';
import ChangePasswordForm from './views/login/ChangePasswordForm';
import { getSrvCfg } from './utils/storage';

/**
 * Change password component
 * @module
 * @param {bool} isOpenChangePassword - Is dialog open? 
 * @param {func} handleConfirmChangePassword - Function on password change submit
 * @param {func} handleClose - Closes dialog function
 * @param {(string | number)} value - Value
 * 
 */
const ChangePassword = (props) => {
  const config = getSrvCfg()
  const pattern = config?.value?.loginConfig?.portal?.password?.pattern
  const patternText = config?.value?.loginConfig?.portal?.password?.errorMessage

  const handleConfirm = (newPassword) => {
    props.handleConfirmChangePassword(newPassword);
    props.handleClose();
  };

  return (
    <Dialog
      isOpen={props.isOpenChangePassword}
      onClose={props.handleClose}
      onConfirm={handleConfirm}
      title=""
      width={450}
      hideButtons={true}
    >
      <div className='change-password'>
        <ChangePasswordForm
          pattern={pattern}
          patternText={patternText}
          changePassword={handleConfirm}
        />
      </div>
    </Dialog>
  );

}

ChangePassword.propTypes = {
  isOpenChangePassword: PropTypes.bool.isRequired,
  handleConfirmChangePassword: PropTypes.func.isRequired,
  handleClose: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
}

export default withMeta(ChangePassword);